import React from 'react'
import { browserLogger } from 'src/utils/browser-logger'
import { useAuthData } from 'src/components/auth/util'
import { useRouter } from 'next/router'
import { useAfterMountEffect } from 'src/hooks/use-after-mount-effect'

export const Intercom: React.FC = () => {
  const authData = useAuthData()
  const router = useRouter()
  const { asPath } = router
  const pathname = new URL(asPath, window.location.origin).pathname

  const intercom =
    (window as any).Intercom ||
    function Fake(...args: any[]) {
      browserLogger.info('intercom not loaded', { args })
    }

  React.useEffect(() => {
    try {
      if (!authData) {
        return
      }

      intercom('boot', {
        app_id: 'uay92az3',
        email: authData.email,
        user_id: authData.id,
        last_seen: new Date(),
      })
    } catch (error) {
      browserLogger.error('error initializing userback', { error })
    }

    return () => {
      if (authData) {
        intercom('shutdown')
      }
    }
  }, [Boolean(authData?.email)])

  useAfterMountEffect(() => {
    if (!authData) {
      return
    }

    intercom('update', {
      app_id: 'uay92az3',
      email: authData.email,
      user_id: authData.id,
      last_seen: new Date(),
    })
  }, [authData?.email, pathname])

  return null
}
